"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformStargateApi = void 0;
const ResourcesApi_1 = require("./commons/ResourcesApi");
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
/**
 * The stargate api.
 */
class SdPlatformStargateApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "stargate";
    }
    /**
     * Gets the stargate config.
     */
    getConfig() {
        return this.__get(SdPlatformRequestId_1.RequestId.StargateGetConfig, "config");
    }
}
exports.SdPlatformStargateApi = SdPlatformStargateApi;
//# sourceMappingURL=SdPlatformStargateApi.js.map